import { create } from 'zustand'
import type { Agent } from '@/services/api/models/Agent'
import type { PaginationInfo } from '@/services/api/models/PaginationInfo'
import type { InvitationResponse } from '@/services/api/models/InvitationResponse'
import type { SharedAgentResponse } from '@/services/api/models/SharedAgentResponse'
import type { AgentFilters } from '@/hooks/useAgents'

export type AgentsTabType = 'my-agents' | 'shared-agents' | 'invitations'

interface AgentsPageState {
  // Data shown in the list (merged across pages for infinite scroll)
  allAgents: Agent[]
  pagination: PaginationInfo | null
  currentPage: number
  filters: AgentFilters
  activeTab: AgentsTabType
  // UI state
  scrollTop: number
  // Invitations tab state
  invitations: InvitationResponse[]
  // Shared agents tab state
  sharedAgents: SharedAgentResponse[]

  // Actions
  setAllAgents: (agents: Agent[] | ((prev: Agent[]) => Agent[])) => void
  setPagination: (pagination: PaginationInfo | null) => void
  setCurrentPage: (page: number) => void
  setFilters: (filters: AgentFilters) => void
  setActiveTab: (tab: AgentsTabType) => void
  setScrollTop: (scrollTop: number) => void
  setInvitations: (invitations: InvitationResponse[]) => void
  setSharedAgents: (sharedAgents: SharedAgentResponse[]) => void
  reset: () => void
}

export const useAgentsPageStore = create<AgentsPageState>((set) => ({
  allAgents: [],
  pagination: null,
  currentPage: 1,
  filters: {},
  activeTab: 'my-agents',
  scrollTop: 0,
  invitations: [],
  sharedAgents: [],

  setAllAgents: (agents) => { 
    set((state) => ({
      allAgents: typeof agents === 'function' ? agents(state.allAgents) : agents
    }))
  },
  setPagination: (pagination) => { set({ pagination }) },
  setCurrentPage: (page) => { set({ currentPage: page }) },
  setFilters: (filters) => { set({ filters }) },
  setActiveTab: (tab) => { set({ activeTab: tab }) },
  setScrollTop: (scrollTop) => { set({ scrollTop }) },
  setInvitations: (invitations) => { set({ invitations }) },
  setSharedAgents: (sharedAgents) => { set({ sharedAgents }) },
  reset: () => { set({
    allAgents: [],
    pagination: null,
    currentPage: 1,
    filters: {},
    activeTab: 'my-agents',
    scrollTop: 0,
    invitations: [],
    sharedAgents: [],
  }) },
}))


